import * as React from "react";
import styled from "../../../styled/index";
import { CS } from "../../../styles/index";
import { TopNavMenu as Menu } from "./nav";
import { shadeAlternate } from "../../../styled/helpers";
const WrapperComponent = styled("menu") `
  position: fixed;
  z-index: 10;
  display: block;
  top: 0;
  left: 0;
  right: 0;
  height: ${({ theme }) => theme.top_nav.height}px;
  background: ${({ theme }) => theme.top_nav.background_color};
  ${CS.shadow.light.two};
`;
const ContentComponent = styled("div") `
  display: flex;
  align-items: center;
  justify-content: ${({ align }) => align};
  padding: 0 20px;
  width: 100%;
  height: 100%;
  max-width: ${({ width, theme }) => width === "full" ? "100%" : `${theme.content_width[width]}px`};
  margin: 0 auto;
  > * {
    margin: 0 20px;
    &:first-child {
      margin-left: 0
    }
    &:last-child {
      margin-right: 0
    }
  }
`;
const LogoComponent = styled("div") `
  span {
    font-size: 20px;
    font-weight: 600;
  }
  img {
    max-height: ${({ theme }) => theme.top_nav.height - 28}px;
  }
`;
const IconWrapper = styled("div") `
  padding: 8px;
  cursor: pointer;
  border-radius: 5px;
  transition: 0.2s background;
  &:hover {
    background: ${({ theme }) => shadeAlternate(0.08, theme.top_nav.background_color)};
  }
`;
const IconComponent = styled("div") `
  font-size: 20px;
`;
const Content = (props) => React.createElement(ContentComponent, { ...props }, props.children);
const Logo = (props) => React.createElement(LogoComponent, { ...props }, props.children);
const Icon = (props) => React.createElement(IconWrapper, { ...props },
    React.createElement(IconComponent, null, props.children));
class Wrapper extends React.Component {
    render() {
        const root = document.getElementById("scroll-root");
        const scrollBarWidth = window.innerWidth - root.clientWidth;
        const { props } = this;
        const style = props.style || {};
        style.marginRight = `${scrollBarWidth}px`;
        return (React.createElement(WrapperComponent, { ...props, style: style }, props.children));
    }
}
export const TopNav = {
    Wrapper, Content, Logo, Menu, Icon,
};
//# sourceMappingURL=index.js.map